var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.65 14.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.42C-.06,3.23,3.3,.06,7.22,0c4.04-.06,7.35,3.19,7.43,7.18,.08,4.04-3.14,7.4-7.27,7.46C3.45,14.69,.04,11.56,0,7.42Zm14.07-.1c.02-3.68-2.97-6.71-6.69-6.75C3.62,.54,.58,3.57,.58,7.27c0,3.78,2.98,6.83,6.83,6.81,3.46-.02,6.67-2.84,6.67-6.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.13,13.41c-.89,.01-1.72-.21-2.51-.62-.67-.35-1.26-.81-1.78-1.35-.15-.15-.17-.3-.09-.49,.26-.58,.59-1.11,1.06-1.55,.61-.55,1.33-.86,2.13-.96,.78-.1,1.57-.12,2.36-.04,.51,.05,1.01,.14,1.49,.34,.79,.34,1.38,.89,1.8,1.63,.11,.2,.19,.4,.29,.61,.08,.16,.04,.3-.07,.42-.3,.34-.64,.64-1.02,.9-.81,.56-1.72,.88-2.69,1.01-.33,.04-.66,.07-.98,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33,7.78c-1.5,0-2.65-1.16-2.65-2.65,0-1.48,1.18-2.65,2.67-2.65,1.44,0,2.63,1.2,2.62,2.66,0,1.45-1.19,2.64-2.64,2.64Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.7db716f025c1a936b3b11146e22bff52.svg";
export { ForwardRef as ReactComponent };